var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Button from '@doordash/component-button';
import * as React from 'react';
// This is a shim meant to mock a react router link
var Link = function (props) {
    return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    React.createElement("a", __assign({}, props)));
};
export var WrappedLink = function (props) { return React.createElement(Link, __assign({}, props, { to: props.href })); };
var NavButton = function (props) { return React.createElement(Button, __assign({}, props, { tag: WrappedLink })); };
export default NavButton;
